import React, { Component } from "react";
import LayoutPage from "../LayoutIdentificationPages";
import RequestResetPasswordForm from "./RequestResetPasswordForm";

class RequestResetPassword extends Component {
  render() {
    return (
      <LayoutPage
        title="Mot de passe oublié ?"
        subtitle="Nous vous enverrons un email avec les instructions pour réinitialiser votre mot de passe."
      >
        <RequestResetPasswordForm />
      </LayoutPage>
    );
  }
}

export default RequestResetPassword;
